import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";

const roomActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
}

export default roomActions;